import React from "react";

export const Page = ({ title, subtitle, action, children }) => (
  <div className="space-y-8">
    <div className="flex items-end justify-between gap-4 flex-wrap">
      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-primary mb-2">SmartStockAI</p>
        <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight">{title}</h1>
        {subtitle && <p className="text-muted-foreground mt-2 max-w-2xl">{subtitle}</p>}
      </div>
      {action}
    </div>
    {children}
  </div>
);

export const StatCard = ({ icon: Icon, label, value, hint, accent = false, testid }) => (
  <div data-testid={testid} className={`p-6 rounded-xl border bg-card transition-all hover:-translate-y-1 ${accent ? "border-primary/40 glow-coral" : "border-border hover:border-primary/30"}`}>
    <div className="flex items-center justify-between">
      <div className="text-xs uppercase tracking-wider text-muted-foreground">{label}</div>
      {Icon && <Icon className={`w-4 h-4 ${accent ? "text-primary" : "text-muted-foreground"}`} />}
    </div>
    <div className={`font-display text-3xl sm:text-4xl font-bold mt-3 ${accent ? "text-primary" : ""}`}>{value}</div>
    {hint && <div className="text-xs text-muted-foreground mt-2">{hint}</div>}
  </div>
);

export const Section = ({ title, action, children }) => (
  <section className="space-y-4">
    <div className="flex items-center justify-between">
      <h2 className="font-display text-xl font-semibold">{title}</h2>
      {action}
    </div>
    {children}
  </section>
);

export const Empty = ({ title, desc, cta }) => (
  <div className="p-12 rounded-xl border border-dashed border-border bg-card/40 text-center">
    <div className="font-display text-lg font-medium">{title}</div>
    {desc && <div className="text-sm text-muted-foreground mt-2 max-w-md mx-auto">{desc}</div>}
    {cta && <div className="mt-5">{cta}</div>}
  </div>
);

export const SeverityBadge = ({ severity }) => {
  const map = {
    critical: "bg-red-500/15 text-red-400 border-red-500/30",
    high: "bg-orange-500/15 text-orange-400 border-orange-500/30",
    medium: "bg-yellow-500/15 text-yellow-400 border-yellow-500/30",
    low: "bg-blue-500/15 text-blue-400 border-blue-500/30",
  };
  const labels = { critical: "Crítico", high: "Alto", medium: "Médio", low: "Baixo" };
  return (
    <span className={`text-xs px-2 py-0.5 rounded-md border ${map[severity] || map.low}`}>
      {labels[severity] || severity}
    </span>
  );
};

export const formatBRL = (n) => `R$ ${Number(n || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
